<template>
    <a-layout id="group_chat" class="page_layout">
        <a-layout-content class="page_content single">
            <groupChat type="list" />
        </a-layout-content>
    </a-layout>
</template>

<script>
import groupChat from '@/components/page/client/groupChat';
export default {
    components: {
        groupChat
    }
};
</script>
